export enum AddUserTabs {
  AddUser = 'Add User',
  BulkAddUser = 'Bulk Add User'
}

export enum UserSettingsTabs {
  Profile = 'Profile',
  Site = 'Site Controls'
}
  